import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footer-bar" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row text-muted" };
const _hoisted_4 = { class: "col d-none d-sm-block" };
const _hoisted_5 = { class: "navbar-nav" };
const _hoisted_6 = { class: "col" };
const _hoisted_7 = { class: "d-flex justify-content-center justify-content-sm-end" };
const _hoisted_8 = {
    key: 0,
    class: "navbar-nav"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("ul", _hoisted_5, [
                        _createElementVNode("li", null, _toDisplayString(_ctx.$host.config.footerInfo), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        (_ctx.footerMenuEntriesRight.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerMenuEntriesRight, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: _normalizeClass(['nav-link', menuItem.cssClasses])
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target", "class"])
                                    ]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ])
    ]));
}
